import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  styled,
} from '@mui/material';

const indices = [
  {
    title: "Indices des prix à la consommation (IPC)",
    link: "/indicesPrixConsommation",
    description: "L'IPC permet de suivre l'évolution des prix des biens et services essentiels pour les ménages au Burundi. Période de 2017 à 2025."
},
{
  title: "Indices du commerce extérieur (ICE)",
  link: "indicesCommerceExterieur",
  description: "L'ICE permet d'évaluer la performance des échanges internationaux du Burundi en analysant les exportations et les importations du pays. Période de 2014 à 2024."
},
  {
    title: "Indices du chiffre d'affaires au Burundi (ICA)",
    link: "/indiceChiffreAffaires",
    description: "L'ICA permet d'évaluer l'activité économique des entreprises locales et offre un aperçu de la dynamique du chiffre d'affaires. Période de 2020 à 2024."
  },
  {
    title: "Indices harmonisés de la production industrielle (IHPI)",
    link: "indicesHarmonisesProductionIndustrielle",
    description: "L'IHPI permet d'examiner la production industrielle du Burundi en conformité avec les normes internationales et offre une comparaison globale de l'activité industrielle. Période de 2019 à 2024."
  },
  {
    title: "Indices des prix à la production agricole (IPPA)",
    link: "indicePrixProductionAgricole",
    description: "L'IPPA permet de surveiller les prix des produits agricoles directement à la source et est utile pour comprendre les revenus des agriculteurs et l'inflation alimentaire. Période de 2023 à 2024."
  },
  {
    title: "Indices du coût de construction de logements neufs au Burundi (ICCLB)",
    link: "indiceCoutConstruction",
    description: "L'ICCLB permet de Planifier des projets immobiliers avec précision et d'informe sur les coûts actuels de construction de logements neufs au Burundi. Période de 2019 à 2025."
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: '#388E3C', 
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
}));

function Indice() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
        <Typography variant="h5" fontWeight="bold" gutterBottom>
                       <br />  
                  </Typography>
      <Container maxWidth="lg" style={{ paddingTop: '20px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Indices 
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
         Cette section vous offre un accès direct aux indices économiques essentiels pour comprendre et analyser les tendances actuelles.
        </Typography>

        <Grid container spacing={1} style={{ marginTop: '20px' }}>
          {indices.map((indice, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StyledCard>
                <StyledCardActionArea href={indice.link}  rel="noopener noreferrer">
                  <StyledCardContent>
                    <TitleTypography variant="h6" component="div">
                      {indice.title}
                    </TitleTypography>
                    <DescriptionTypography variant="body2">
                      {indice.description}
                    </DescriptionTypography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Indice;